import { cn } from '@/utils/styles';

const dotBg =
  "checked:bg-[image:var(--radio-dot)] checked:bg-no-repeat checked:bg-center checked:bg-[length:12px_12px]";

export const colors = {
  primary: cn(
    // base
    'bg-white border-neutral-50 hover:border-primary-700',
    // focus
    'focus:border-primary-700 focus:ring-primary-50 focus:shadow-primary',
    // checked
    'checked:border-primary-700 checked:bg-primary-700',
    'checked:hover:border-primary-800 checked:hover:bg-primary-800',
    dotBg,
    'disabled:border-neutral-50 disabled:bg-base-disabled',
    'disabled:checked:border-neutral-50 disabled:checked:bg-base-disabled'
  ),

  secondary: cn(
    'bg-white border-neutral-50 hover:border-base-primary',
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',
    'checked:border-secondary-accent checked:bg-secondary-accent',
    dotBg
  ),

  neutral: cn(
    'bg-white border-neutral-50 hover:border-base-primary',
    'focus:border-base-primary focus:ring-neutral-200 focus:shadow-sm',
    'checked:border-base-primary checked:bg-base-primary',
    dotBg
  ),

  warning: cn(
    'bg-white border-warning-400 hover:border-warning-400',
    'focus:border-warning-400 focus:ring-warning-200 focus:shadow-warning',
    'checked:border-warning-400 checked:bg-warning-400',
    dotBg
  ),

  error: cn(
    'bg-white border-secondary-accent/80 hover:border-secondary-accent',
    'focus:border-secondary-accent focus:ring-secondary-50 focus:shadow-secondary',
    'checked:border-secondary-accent checked:bg-secondary-accent',
    dotBg
  ),
} as const;
